// FIELDS FROM BACKEND

export enum SIGN_UP_FIELDS {
  // START

  SAVING_FOR = 'savingFor',
  SAVING_FOR_OTHER = 'savingForOther',
  WHAT_FOR = 'savingWhatFor',
  WHAT_FOR_OTHER = 'savingWhatForOther',
  HOW_MUCH = 'savingHowMuch',
  HOW_MUCH_CURRENCY = 'savingHowMuchCurrency',

  ACCOUNT_TYPE = 'accountType',
  EMAIL = 'email',
  PASSWORD = 'password',
  PASSWORD_REPEAT = 'repeatPassword',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  DOB = 'dob',
  PHONE = 'phone',
  PHONE_COUNTRY = 'phoneCountry', // don't delete must be saved on BE for init phone component

  // ADDRESS

  PHONE_CONFIRMED = 'phoneConfirmed',
  COUNTRY_CODE = 'countryCode',
  STREET_AND_NUMBER = 'streetAndNumber',
  CITY = 'city',
  POSTAL_ZIP_CODE = 'postalZipCode',

  // DOCS
  PERSON_PPS = 'personPps',
  DOC_TYPE = 'docType',
  COMPANY_VAT = 'companyVat',
  DOCUMENTS_LIST = 'docsList',
  DOCUMENTS_NAMES = 'docsNames',

  // FINISH
  ACCOUNT_BANK_CURRENCY = 'account_bank_currency',
  ACCOUNT_HOLDER_NAME = 'account_holder_name',
  ACCOUNT_IBAN = 'account_iban',

  REGISTRATION_IP = 'registrationIp',
}
